// The app mark: the USP emblem (public/logo.png), used in the header and
// onboarding popup.
const AppMark = ({ size = 48 }) => (
  <img
    src="/logo.png"
    alt="USP emblem"
    width={size}
    height={size}
    className="shrink-0 rounded-full shadow-[0_8px_20px_-10px_rgba(4,48,44,0.7)]"
  />
);

export default AppMark;
